import $ from 'jquery';
import ParentPageBaseClass from './parts/common/ParentPageBaseClass';
import PreloaderClass from './parts/common/PreloaderClass';

/**
 * 画面ローダー PC・SP共通クラス
 */
class TranslucentLoaderClass extends ParentPageBaseClass {
  constructor() {
    super();
    this.name = 'InnerLoaderClass';
  }

  onCreate() {
    this.inner = new PreloaderClass($('#page_preloader'));
    this.inner.onHide();
  }
}
export const pageCl = new TranslucentLoaderClass();
